import "./SecondaryScreen.css";

import React, { ReactNode, useRef } from "react";
import { useNavigate } from "react-router-dom";

import { FaqModalRef } from "./FaqModal";
import BrandLockup from "./BrandLockup/BrandLockup";

interface SecondaryScreenProps {
  logoSrc: string;
  iconOne: string;
  iconTwo: string;
  children?: ReactNode;
  onclick?: () => void;
}

const SecondaryScreen: React.FC<SecondaryScreenProps> = ({ logoSrc, iconOne, children }) => {
  const navigate = useNavigate();
  const faqModal = useRef<FaqModalRef>(null);

  return (
    <div className="my-component">
      <div className="top-section">
        <BrandLockup logoClassName="logo-energiav-new" onLogoClick={() => navigate("/")} />

        <button onClick={() => faqModal.current?.open()}>
          <img src={iconOne} alt="Icon-One" className="question-lado-direito" />
        </button>
      </div>

      <div className="middle-section">{children}</div>

      {/* <img
        src={seloIVI}
        alt="A energia solar por assinatura é oferecida em parceria com a IVI Energia."
        className="secondary-screen-selo-ivi"
      /> */}

    </div>
  );
};

export default SecondaryScreen;
